var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gvl-privacy" }, [
      _c(
        "div",
        {
          staticClass: "field-item even",
          attrs: { property: "content:encoded" }
        },
        [
          _c("h3", [
            _c("strong", [_vm._v("Datenschutzerklärung nach der DSGVO")])
          ]),
          _vm._v(" "),
          _c("h4", { staticClass: "mt-8" }, [
            _c("strong", [_vm._v("I. Name und Anschrift des Verantwortlichen")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Der Verantwortliche im Sinne der Datenschutz-Grundverordnung und anderer nationaler Datenschutzgesetze der Mitgliedsstaaten sowie sonstiger datenschutzrechtlicher Bestimmungen ist die:"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Gesellschaft zur Verwertung von Leistungsschutzrechten mbH")
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Podbielskiallee 64")]),
          _vm._v(" "),
          _c("p", [_vm._v("14195 Berlin")]),
          _vm._v(" "),
          _c("p", [_vm._v("Deutschland")]),
          _vm._v(" "),
          _c("p", [_vm._v("Telefon: 0202-2515 57305")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("E-Mail: "),
            _c(
              "a",
              {
                attrs: {
                  href: "mailto:kontakt@gvl-stipendienprogramm.de",
                  rel: "nofollow"
                }
              },
              [_vm._v("kontakt@gvl-stipendienprogramm.de")]
            ),
            _vm._v(
              " (Anfragen zum Stipendienprogramm bitte an die Hotline richten.)"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Website: "),
            _c(
              "a",
              { attrs: { href: "http://www.gvl.de", target: "_blank" } },
              [_vm._v("www.gvl.de")]
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [_vm._v("II. Kontakt des Datenschutzbeauftragten")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Unseren betrieblichen Datenschutzbeauftragten erreichen Sie unter:"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Datenschutzbeauftragter")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Gesellschaft zur Verwertung von Leistungsschutzrechten mbH "
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Podbielskiallee 64")]),
          _vm._v(" "),
          _c("p", [_vm._v("14195 Berlin")]),
          _vm._v(" "),
          _c("p", [_vm._v("Deutschland")]),
          _vm._v(" "),
          _c("p", [_vm._v("Tel.: +49 30 48483600")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("E-Mail: "),
            _c(
              "a",
              { attrs: { href: "mailto:datenschutz@gvl.de", rel: "nofollow" } },
              [_vm._v("datenschutz@gvl.de")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Website: "),
            _c(
              "a",
              { attrs: { href: "http://www.gvl.de", target: "_blank" } },
              [_vm._v("www.gvl.de")]
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [_vm._v("III. Allgemeines zur Datenverarbeitung")])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Umfang der Verarbeitung personenbezogener Daten")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Wir verarbeiten Ihre personenbezogenen Daten grundsätzlich nur, soweit dies zur Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist. Die Verarbeitung Ihrer personenbezogenen Daten erfolgt regelmäßig nur nach Ihrer Einwilligung. Eine Ausnahme gilt in solchen Fällen, in denen die vorherige Einholung einer Einwilligung aus tatsächlichen Gründen nicht möglich ist und die Verarbeitung der Daten durch gesetzliche Vorschriften gestattet ist."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(
                "2. Rechtsgrundlage für die Verarbeitung personenbezogener Daten"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Soweit wir für Verarbeitungsvorgänge Ihrer personenbezogener Daten eine Einwilligung einholen, dient Art. 6 Abs. 1 lit. a EU-Datenschutzgrundverordnung (DSGVO) als Rechtsgrundlage."
            ),
            _c("br"),
            _vm._v(
              "Bei der Verarbeitung Ihrer personenbezogenen Daten, die zur Erfüllung eines Vertrages mit Ihnen erforderlich ist, dient Art. 6 Abs. 1 lit. b DSGVO als Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind."
            ),
            _c("br"),
            _vm._v(
              "Soweit eine Verarbeitung personenbezogener Daten zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der unser Unternehmen unterliegt, dient Art. 6 Abs. 1 lit. c DSGVO als Rechtsgrundlage."
            ),
            _c("br"),
            _vm._v(
              "Ist die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens oder eines Dritten erforderlich und überwiegen die Interessen Ihrer Grundrechte und Grundfreiheiten das erstgenannte Interesse nicht, so dient Art. 6 Abs. 1 lit. f DSGVO als Rechtsgrundlage für die Verarbeitung."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("3. Datenlöschung und Speicherdauer")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Ihre personenbezogenen Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt. Eine Speicherung kann darüber hinaus erfolgen, wenn dies durch den europäischen oder nationalen Gesetzgeber in unionsrechtlichen Verordnungen, Gesetzen oder sonstigen Vorschriften, denen der Verantwortliche unterliegt, vorgesehen wurde. Eine Sperrung oder Löschung der Daten erfolgt auch dann, wenn eine durch die genannten Normen vorgeschriebene Speicherfrist abläuft, es sei denn, dass eine Erforderlichkeit zur weiteren Speicherung der Daten für einen Vertragsabschluss oder eine Vertragserfüllung besteht."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [
              _vm._v(
                "IV. Bereitstellung der Website und Erstellung von Logfiles"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Bei jedem Aufruf unserer Internetseite erfasst unser System automatisiert Daten und Informationen vom Computersystem des aufrufenden Rechners. "
            ),
            _c("br"),
            _vm._v("Folgende Daten werden hierbei erhoben:")
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "Informationen über den Browsertyp und die verwendete Version"
              )
            ]),
            _vm._v(" "),
            _c("li", [_vm._v("Das Betriebssystem des verwendeten Rechners")]),
            _vm._v(" "),
            _c("li", [_vm._v("Den genutzten Internet-Service-Provider")]),
            _vm._v(" "),
            _c("li", [_vm._v("Datum und Uhrzeit des Zugriffs")]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Websites, von denen das System des verwendeten Rechners auf unsere Internetseite gelangt"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Websites, die vom System des verwendeten Rechners über unsere Website aufgerufen werden"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden ebenfalls in den Logfiles unseres Systems gespeichert. Nicht hiervon betroffen sind Ihre IP-Adressen oder andere Daten, die die Zuordnung zu Ihren Daten ermöglichen. Eine Speicherung dieser Daten zusammen mit Ihren anderen personenbezogenen findet nicht statt."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage für die Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die vorübergehende Speicherung der Daten ist Art. 6 Abs. 1 lit. f DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("3. Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die vorübergehende Speicherung der IP-Adresse durch das System ist notwendig, um eine Auslieferung der Website an Ihren Rechner zu ermöglichen. Hierfür muss Ihre IP-Adresse für die Dauer der Sitzung gespeichert bleiben."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung nach Art. 6 Abs. 1 lit. f DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Dauer der Speicherung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Im Falle der Erfassung der Daten zur Bereitstellung der Website ist dies der Fall, wenn die jeweilige Sitzung beendet ist."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Erfassung der Daten zur Bereitstellung der Website und die Speicherung der Daten in Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich für Sie keine Widerspruchsmöglichkeit."
            )
          ]),
          _vm._v(" "),
          _c("h4", [_c("strong", [_vm._v("V. Verwendung von Cookies")])]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("a) Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Unsere Webseite verwendet Cookies. Bei Cookies handelt es sich um Textdateien, die im Internetbrowser bzw. vom Internetbrowser auf Ihrem Computersystem gespeichert werden. Rufen Sie eine Website auf, so kann ein Cookie auf Ihrem Betriebssystem gespeichert werden. Dieser Cookie enthält eine charakteristische Zeichenfolge, die eine eindeutige Identifizierung des Browsers beim erneuten Aufrufen der Website ermöglicht. "
            ),
            _c("br"),
            _vm._v(
              "Wir setzen Cookies ein, um unsere Website nutzerfreundlicher zu gestalten. Einige Elemente unserer Internetseite erfordern es, dass der aufrufende Browser auch nach einem Seitenwechsel identifiziert werden kann."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("b) Rechtsgrundlage für die Datenverarbeitung ")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Rechtsgrundlage für die Verarbeitung personenbezogener Daten unter Verwendung von Cookies ist Art. 6 Abs. 1 lit. f DSGVO"
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("c) Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Der Zweck der Verwendung technisch notwendiger Cookies ist, die Nutzung von Websites für Sie zu vereinfachen. Einige Funktionen unserer Internetseite können ohne den Einsatz von Cookies nicht angeboten werden. Für diese ist es erforderlich, dass der Browser auch nach einem Seitenwechsel wiedererkannt wird."
            ),
            _c("br"),
            _vm._v(
              "Die durch technisch notwendige Cookies erhobenen Nutzerdaten werden nicht zur Erstellung von Nutzerprofilen verwendet."
            ),
            _c("br"),
            _vm._v(
              "Die Verwendung der Analyse-Cookies erfolgt zu dem Zweck, die Qualität unserer Website und ihrer Inhalte zu verbessern. Durch die Analyse-Cookies erfahren wir, wie die Website genutzt wird und können so unser Angebot stetig optimieren."
            ),
            _c("br"),
            _vm._v(
              "In diesen Zwecken liegt auch unser berechtigtes Interesse an der Verarbeitung der personenbezogenen Daten nach Art. 6 Abs. 1 lit. f DSGVO. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(
                "d) Dauer der Speicherung, Widerspruchs- und Beseitigungsmöglichkeit"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Cookies werden auf dem genutzten Rechner gespeichert und von diesem an unserer Seite übermittelt. Daher haben Sie auch die volle Kontrolle über die Verwendung von Cookies. Durch eine Änderung der Einstellungen in Ihrem Internetbrowser können Sie die Übertragung von Cookies deaktivieren oder einschränken. Bereits gespeicherte Cookies können jederzeit gelöscht werden. Dies kann auch automatisiert erfolgen. Werden Cookies für unsere Website deaktiviert, können möglicherweise nicht mehr alle Funktionen der Website vollumfänglich genutzt werden."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [
              _vm._v("VI. Anmeldung zum Online-Wahrnehmungsvertrag")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Auf unserer Internetseite bieten wir Ihnen die Möglichkeit, sich unter Angabe personenbezogener Daten für den Abschluss eines Wahrnehmungsvertrags anzumelden. Die Daten werden dabei in eine Eingabemaske eingegeben und an uns übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte findet nicht statt. Folgende Daten werden im Rahmen des Anmeldeprozesses für den Abschluss eines Wahrnehmungsvertrages erhoben:"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Personenstammdaten (Name, Vorname, Geburtsname,..)"),
            _c("br"),
            _vm._v("Adressdaten"),
            _c("br"),
            _vm._v("Kontaktdaten"),
            _c("br"),
            _vm._v("Angaben zur künstlerischen Tätigkeit"),
            _c("br"),
            _vm._v("Zahlungsdaten"),
            _c("br"),
            _vm._v("Steuerdaten")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage für die Datenverarbeitung ")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung Ihrer Daten bei der Anmeldung zum Abschluss eines Wahrnehmungsvertrags  bzw. zur Durchführung hierfür vorvertraglicher Maßnahmen ist Art. 6 Abs. 1 lit. b DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("3. Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Anmeldung ist zum Abschluss und zur Erfüllung eines Wahrnehmungsvertrages mit Ihnen oder zur Durchführung vorvertraglicher Maßnahmen erforderlich."
            ),
            _c("br"),
            _vm._v(
              "Das Unternehmen benötigt Ihre personenbezogenen Daten zur treuhänderischen Wahrnehmung der von Ihnen durch den Wahrnehmungsvertrag übertragenen Rechte und zur Auszahlung etwaiger Verteilungsansprüche, welche aus der Nutzung der übertragen Rechte erfolgen können."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Dauer der Speicherung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Dies ist für die während des Anmeldevorgangs zum Abschluss und zur Erfüllung des Wahrnehmungsvertrags oder zur Durchführung vorvertraglicher Maßnahmen dann der Fall, wenn die Daten für die Durchführung des Wahrnehmungsvertrages nicht mehr erforderlich sind. Nach Abschluss des Wahrnehmungsvertrags kann eine Erforderlichkeit, personenbezogene Daten des Vertragspartners zu speichern, bestehen, um vertraglichen oder gesetzlichen Verpflichtungen nachzukommen."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sind die Daten zum Abschluss und zur Erfüllung eines Wahrnehmungsvertrags oder zur Durchführung vorvertraglicher Maßnahmen erforderlich, ist eine vorzeitige Löschung der Daten nur möglich, soweit nicht vertragliche oder gesetzliche Verpflichtungen einer Löschung entgegenstehen."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [_vm._v("VII. ")]),
            _vm._v("Nutzung der Künstlerportale meine.gvl und artsys.gvl")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Unter "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.artsys.gvl.de/login",
                  target: "_blank",
                  rel: "nofollow"
                }
              },
              [_vm._v("www.meine.gvl.de")]
            ),
            _vm._v(" und "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.artsys.gvl.de/login",
                  target: "_blank",
                  rel: "nofollow"
                }
              },
              [_vm._v("www.artsys.gvl.de")]
            ),
            _vm._v(
              " können Sie als wahrnehmungsberechtigter Künstler Ihre Mitwirkungen an Produktionen melden. Zudem können Sie einen Teil Ihrer dort für Sie einsehbaren gespeicherten personenbezogenen Daten bearbeiten. Die Daten werden dabei in eine Eingabemaske eingegeben und an uns übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte findet im Falle der internationalen Rechtewahrnehmung statt. Folgende Daten werden im Rahmen der Nutzungen der Künstlerportale meine.gvl und artsys.gvl verarbeitet:"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Personenstammdaten (Name, Vorname, Geburtsname,..)"),
            _c("br"),
            _vm._v("Adressdaten"),
            _c("br"),
            _vm._v("Kontaktdaten"),
            _c("br"),
            _vm._v("Kundennummer"),
            _c("br"),
            _vm._v("Angaben zur künstlerischen Tätigkeit"),
            _c("br"),
            _vm._v("Zahlungsdaten"),
            _c("br"),
            _vm._v("Steuerdaten")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage für die Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung Ihrer Daten im Rahmen der Nutzungen der Künstlerportale meine.gvl und artsys.gvl zur Erfüllung des Wahrnehmungsvertrags ist Art. 6 Abs. 1 lit. b DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("3. Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Erst durch das Melden Ihrer Mitwirkungen an den Produktionen können wir Ihren Vergütungsanspruch ermitteln, welcher aus der Nutzung der im Rahmen des Wahrnehmungsvertrags übertragenen Rechte erfolgen kann."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Dauer der Speicherung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Dies ist dann der Fall, wenn die Daten zur Erfüllung des Wahrnehmungsvertrags nicht mehr erforderlich sind. Es besteht jedoch die Möglichkeit, dass die Speicherung Ihrer personenbezogenen Daten auch nach Beendigung des Wahrnehmungsvertrags erforderlich ist, um vertraglichen oder gesetzlichen Verpflichtungen nachzukommen."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sind die Daten zur Erfüllung des Wahrnehmungsvertrags erforderlich, ist eine vorzeitige Löschung der Daten nur möglich, soweit nicht vertragliche oder gesetzliche Verpflichtungen einer Löschung entgegenstehen."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [
              _vm._v("VIII. Nutzung des Herstellerportals label.gvl")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Unter "),
            _c(
              "a",
              { attrs: { href: "https://label.gvl.de", target: "_blank" } },
              [_vm._v("https://label.gvl.de")]
            ),
            _vm._v(
              " können Sie als wahrnehmungsberechtigter Tonträgerhersteller Ihr Repertoire melden. Sie erhalten einen Überblick über Ihre Aufnahmen und deren Sendeminuten. Zudem können Sie einen Teil Ihrer dort für Sie einsehbaren gespeicherten personenbezogenen Daten bearbeiten. Die Daten werden dabei in eine Eingabemaske eingegeben und an uns übermittelt und gespeichert. Eine Weitergabe der Daten an Dritte findet bei internationaler Rechtewahrnehmung und in dem in den Nutzungsbedingungen benannten Fall des Rechteinhaberschaftkonflikts statt. Folgende Daten werden im Rahmen der Nutzung des Herstellerportals label.gvl verarbeitet:"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Personenstammdaten (Name, Vorname, Geburtsname,..)"),
            _c("br"),
            _vm._v("Adressdaten"),
            _c("br"),
            _vm._v("Kontaktdaten"),
            _c("br"),
            _vm._v("Kundennummer"),
            _c("br"),
            _vm._v("Angaben zu Rechteinhaberschaften"),
            _c("br"),
            _vm._v("Zahlungsdaten"),
            _c("br"),
            _vm._v("Steuerdaten")
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage für die Datenverarbeitung ")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung Ihrer Daten im Rahmen der Nutzung des Herstellerportals label.gvl zur Erfüllung des Wahrnehmungsvertrags ist Art. 6 Abs. 1 lit. b DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("3. Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Erst durch das Melden Ihrer Rechteinhaberschaften an den Aufnahmen können wir Ihren Vergütungsanspruch ermitteln, welcher aus der Nutzung der im Rahmen des Wahrnehmungsvertrags übertragenen Rechte erfolgen kann."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Dauer der Speicherung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Dies ist dann der Fall, wenn die Daten zur Erfüllung des Wahrnehmungsvertrags nicht mehr erforderlich sind. Es besteht jedoch die Möglichkeit, dass die Speicherung Ihrer personenbezogenen Daten auch nach Beendigung des Wahrnehmungsvertrags erforderlich ist, um vertraglichen oder gesetzlichen Verpflichtungen nachzukommen."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sind die Daten zur Erfüllung des Wahrnehmungsvertrags erforderlich, ist eine vorzeitige Löschung der Daten nur möglich, soweit nicht vertragliche oder gesetzliche Verpflichtungen einer Löschung entgegenstehen."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [_vm._v("IX. Kontaktformular und E-Mail-Kontakt")])
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Datenverarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Auf unserer Internetseite ist ein Kontaktformular vorhanden, welches für die elektronische Kontaktaufnahme genutzt werden kann. Nehmen Sie diese Möglichkeit wahr, so werden die in der Eingabemaske eingegeben Daten an uns übermittelt und gespeichert. Diese Daten sind:"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Name"),
            _c("br"),
            _vm._v("E-Mail Adresse"),
            _c("br"),
            _vm._v("Telefonnummer"),
            _c("br"),
            _vm._v("GVL-ID")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Für die Verarbeitung der Daten wird im Rahmen des Absendevorgangs Ihre Einwilligung eingeholt und auf diese Datenschutzerklärung verwiesen."
            ),
            _c("br"),
            _vm._v(
              "Alternativ ist eine Kontaktaufnahme über die bereitgestellte E-Mail-Adresse möglich. In diesem Fall werden Ihre mit der E-Mail übermittelten personenbezogenen Daten gespeichert. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Es erfolgt in diesem Zusammenhang keine Weitergabe der Daten an Dritte. Die Daten werden ausschließlich für die Verarbeitung der Konversation verwendet."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage für die Datenverarbeitung ")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen Ihrer Einwilligung, Art. 6 Abs. 1 lit. a DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge einer Übersendung einer E-Mail übermittelt werden, ist Art. 6 Abs. 1 lit. f DSGVO. Zielt der E-Mail-Kontakt auf den Abschluss eines Vertrages ab, so ist zusätzliche Rechtsgrundlage für die Verarbeitung Art. 6 Abs. 1 lit. b DSGVO."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("3. Zweck der Datenverarbeitung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Verarbeitung der personenbezogenen Daten aus der Eingabemaske dient uns allein zur Bearbeitung der Kontaktaufnahme. Im Falle einer Kontaktaufnahme per E-Mail liegt hieran auch das erforderliche berechtigte Interesse an der Verarbeitung der Daten."
            ),
            _c("br"),
            _vm._v(
              "Die sonstigen während des Absendevorgangs verarbeiteten personenbezogenen Daten dienen dazu, einen Missbrauch des Kontaktformulars zu verhindern und die Sicherheit unserer informationstechnischen Systeme sicherzustellen."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Dauer der Speicherung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Für die personenbezogenen Daten aus der Eingabemaske des Kontaktformulars und diejenigen, die per E-Mail übersandt wurden, ist dies dann der Fall, wenn die jeweilige Konversation mit Ihnen beendet ist. Beendet ist die Konversation dann, wenn sich aus den Umständen entnehmen lässt, dass der betroffene Sachverhalt abschließend geklärt ist und keine vertraglichen oder gesetzlichen Gründe für eine weitere notwendige Speicherung der Daten bestehen. "
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Die während des Absendevorgangs zusätzlich erhobenen personenbezogenen Daten werden spätestens nach einer Frist von sieben Tagen gelöscht."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Der Nutzer hat jederzeit die Möglichkeit, seine Einwilligung zur Verarbeitung der personenbezogenen Daten zu widerrufen. Nimmt der Nutzer per E-Mail Kontakt mit uns auf, so kann er der Speicherung seiner personenbezogenen Daten jederzeit widersprechen. In einem solchen Fall kann die Konversation nicht fortgeführt werden."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Für die Ausübung des Widerspruchsrechts genügt eine E-Mail an "
            ),
            _c(
              "a",
              { attrs: { href: "mailto:infomail@gvl.de", rel: "nofollow" } },
              [_vm._v("infomail@gvl.de")]
            ),
            _vm._v(
              " oder eine Mitteilung an die sonstigen in I. bzw. in unserem Impressum genannten Kontaktdaten."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Alle personenbezogenen Daten, die im Zuge der Kontaktaufnahme gespeichert wurden, werden in diesem Fall gelöscht, sofern keine vertraglichen oder gesetzlichen Gründe für eine weitere notwendige Speicherung der Daten bestehen."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("IX.1 Newsletter")])]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("1. Beschreibung und Umfang der Verarbeitung:")
            ]),
            _c("br"),
            _vm._v(
              "Sie haben die Möglichkeit, auf der Website unseren E-Mail-Newsletter zu abonnieren, mit dem wir Sie regelmäßig über aktuelle Entwicklungen bei der GVL informieren."
            ),
            _c("br"),
            _vm._v(
              "Für den Empfang des Newsletters ist die Angabe einer validen E-Mail-Adresse erforderlich. Für die Anmeldung zu unserem Newsletter verwenden wir das sog. Double-opt-in-Verfahren. Das heißt, dass wir Ihnen nach Ihrer Anmeldung eine E-Mail an die angegebene E-Mail-Adresse senden, in welcher wir Sie um Bestätigung bitten, dass Sie den Versand des Newsletters wünschen. Die Bestätigung erfolgt durch Klick auf einen confirm-Link in der E-Mail."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Des Weiteren werden im Zeitpunkt des Abonnements folgende Daten verarbeitet:"
            ),
            _c("br"),
            _vm._v("- IP-Adresse,"),
            _c("br"),
            _vm._v("- Datum/ Uhrzeit der Anmeldung zum Newsletter,"),
            _c("br"),
            _vm._v("- Zeitpunkt Ihrer Bestätigung des confirm-Links.")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Für die Verwaltung der Abonnenten und den Versand des Newsletters nutzen wir den Dienst CleverReach der CleverReach GmbH & Co. KG (Deutschland). In Bezug auf die Verarbeitung personenbezogener Daten haben wir diesen Anbieter vertraglich verpflichtet, die Anforderungen des europäischen Datenschutzrechts einzuhalten."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("2. Rechtsgrundlage: für die Datenverarbeitung")
            ]),
            _c("br"),
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung der Daten ist bei Vorliegen Ihrer Einwilligung, Art. 6 Abs. 1 lit. a DSGVO."
            ),
            _c("br"),
            _vm._v(
              "Rechtsgrundlage für die Verarbeitung der Daten, die im Zuge des Anmeldeprozesses und Übersendung der Newsletter erfolgt, ist Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse)."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("3. Zweck der Datenverarbeitung")]),
            _c("br"),
            _vm._v(
              "Die Verarbeitung der personenbezogenen Daten aus der Eingabemaske dient uns allein dem Versand des Newsletters. Wir verarbeiten Ihre IP-Adresse, den Zeitpunkt der Anmeldung zum Newsletter sowie den Zeitpunkt Ihrer Bestätigung, um Ihre Newsletter-Anmeldung zu dokumentieren und den Missbrauch Ihrer persönlichen Daten zu verhindern."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("4. Dauer der Speicherung")]),
            _c("br"),
            _vm._v(
              "Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht mehr erforderlich sind. Die E-Mail-Adresse des Nutzers wird demnach solange gespeichert, wie das Abonnement aktiv ist. Die automatische Löschung der Daten von abgemeldeten und von nicht bestätigten Empfängern erfolgt nach sieben Tagen."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("5. Widerspruchs- und Beseitigungsmöglichkeit")
            ]),
            _c("br"),
            _vm._v(
              "Soweit Sie mit der Speicherung der Daten zu diesem Zweck nicht mehr einverstanden sind und somit unser Angebot nicht mehr nutzen möchten, können Sie sich jederzeit von unserem Newsletter abmelden. Zu diesem Zweck findet sich in jedem Newsletter ein entsprechender Link. Die von Ihnen angegebenen personenbezogenen Daten werden dann gelöscht."
            )
          ]),
          _vm._v(" "),
          _c("h4", [_c("strong", [_vm._v("X. Plugins und Tools")])]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("Webanalyse durch Google Analytics")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Wir benutzen Google Analytics, einen Webanalysedienst der Google LLC (1600 Amphitheatre Parkway Mountain View, CA 94043, USA; „Google“). Die Nutzung umfasst die Betriebsart „Universal Analytics“. Hierdurch ist es möglich, Daten, Sitzungen und Interaktionen über mehrere Geräte hinweg einer pseudonymen User-ID zuzuordnen und so Ihre Aktivitäten geräteübergreifend zu analysieren. "
            ),
            _c("br"),
            _vm._v(
              "Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen über Ihre Benutzung dieser Website werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert. Auf dieser Website ist die IP-Anonymisierung aktiviert. Ihre IP-Adresse wird von Google innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Die im Rahmen von Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google zusammengeführt. Im Auftrag des Betreibers dieser Website wird Google diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten zusammenzustellen und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen gegenüber dem Websitebetreiber zu erbringen. In diesen Zwecken liegt auch unser berechtigtes Interesse an der Datenverarbeitung. Die Rechtsgrundlage für den Einsatz von Google Analytics ist § 15 Abs. 3 TMG bzw. Art. 6 Abs. 1 lit. f DSGVO. Die von uns gesendeten und mit Cookies, Nutzerkennungen (z. B. User-ID) oder Werbe-IDs verknüpften Daten werden nach 14 Monaten automatisch gelöscht. Die Löschung von Daten, deren Aufbewahrungsdauer erreicht ist, erfolgt automatisch einmal im Monat. Nähere Informationen zu Nutzungsbedingungen und Datenschutz finden Sie unter "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.google.com/analytics/terms/de.html",
                  target: "_blank"
                }
              },
              [_vm._v("https://www.google.com/analytics/terms/de.html")]
            ),
            _vm._v(" bzw. unter "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://policies.google.com/?hl=de",
                  target: "_blank"
                }
              },
              [_vm._v("https://policies.google.com/?hl=de")]
            ),
            _vm._v(".")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der durch das Cookie erzeugten und auf Ihre Nutzung der Website bezogenen Daten (inkl. Ihrer IP-Adresse) an Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem Sie das Browser-Add-on ("
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://tools.google.com/dlpage/gaoptout?hl=de",
                  target: "_blank"
                }
              },
              [_vm._v("https://tools.google.com/dlpage/gaoptout?hl=de")]
            ),
            _vm._v(
              ") herunterladen und installieren. Opt-Out-Cookies verhindern die zukünftige Erfassung Ihrer Daten beim Besuch dieser Website. Um die Erfassung durch Universal Analytics über verschiedene Geräte hinweg zu verhindern, müssen Sie das Opt-Out auf allen genutzten Systemen durchführen. Wenn Sie hier klicken, wird das Opt-Out-Cookie gesetzt: "
            ),
            _c("a", { attrs: { id: "gaOptOut", href: "#", rel: "nofollow" } }, [
              _vm._v("Google Analytics deaktivieren")
            ]),
            _vm._v(".")
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("YouTube")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              'Auf dieser Seite werden Videos über YouTube eingebettet, die auf den Servern des Anbieters YouTube gespeichert werden und von der GVL-Website aus nutzbar sind. Die Einbettung der Videos erfolgt mit aktivierter Option für "Erweiterten Datenschutzmodus aktivieren". Wenn Sie so eingebettete Videos abspielen, werden auf Ihrem Computer Cookies von YouTube und DoubleClick gespeichert und möglicherweise Daten an Google Ireland Limited, Gordon House, 4 Barrow St., Dublin 4, als YouTube-Eigentümer weitergereicht. Sobald die bei YouTube gespeicherten Videos abgespielt werden, werden folgende Daten an Google als YouTube-Betreiber und Betreiber des DoubleClick-Netzwerks übertragen: IP-Adresse, Cookie, die URL der bei mir aufgerufenen Seite, Systemdatum und Zeit des Aufrufs, Kennung des Website-Besucher-Browsers. Die Daten werden nicht erst übertragen, wenn Sie einen Account bei YouTube, bzw. Google haben oder dort eingeloggt sind. Sobald Sie eingeloggt sind, kann Google hier Nutzerverhalten direkt zuordnen. Sie könnten sich vor dem Abspielen des Videos bei Google ausloggen, um diese Art des Trackens einzuschränken. Sie können davon ausgehen, dass Google Ihr Nutzerverhalten dazu nutzen wird, Ihnen Nutzer-spezifische Werbung anzuzeigen. Diese Auswertung wird unabhängig davon stattfinden, ob Sie bei Google eingeloggt sind. Sie können gegen das Erstellen solcher Nutzerprofile Widerspruch einlegen, wobei Sie sich diesbezüglich direkt an Google als Betreiber von YouTube richten müssen. Wir nutzen YouTube und setzen Videos, die bei YouTube gehostet sind ein, um eine ansprechende Darstellung unserer Online-Angebote zu ermöglichen. Mit Videos lassen sich Inhalte besser vermitteln. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar.'
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Weitere Informationen zum Zweck & Umfang der Datenerhebung und ihrer Verarbeitung durch Google erhalten Sie unter: "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://policies.google.com/privacy?hl=de",
                  target: "_blank"
                }
              },
              [_vm._v("https://policies.google.com/privacy?hl=de")]
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("Google reCAPTCHA")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              'Bei Formulareingaben auf unserer Website verwenden wir auch die reCAPTCHA Funktion von Google Ireland Limited, Gordon House, 4 Barrow St., Dublin 4, Irland ("Google"). Diese Funktion dient vor allem zur Unterscheidung, ob eine Eingabe durch eine natürliche Person erfolgt oder missbräuchlich durch maschinelle und automatisierte Verarbeitung erfolgt. Der Dienst inkludiert den Versand der IP-Adresse und ggf. weiterer von Google für den Dienst reCAPTCHA benötigter Daten an Google und erfolgt gemäß Art. 6 Abs. 1 lit. f DGSVO auf Basis unseres berechtigten Interesses - der Vermeidung von Missbrauch und Spam.'
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Weiterführende Informationen zu Google reCAPTCHA sowie die Datenschutzerklärung von Google können Sie einsehen unter: "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://policies.google.com/privacy?hl=de",
                  target: "_blank"
                }
              },
              [_vm._v("https://policies.google.com/privacy?hl=de")]
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("Adobe Fonts")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Für die einheitliche Darstellung bestimmter Schriftarten nutzen wir auf dieser Website sogenannte Adobe Fonts, die von Adobe bereitgestellt werden (Adobe Systems Software Ireland Limited, 4-6 Riverwalk, Citywest Business Campus, Dublin 24, Ireland)."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Beim Aufruf einer Website lädt der Browser der Website-Besucher entsprechende Web Fonts in den Browsercache der Website-Besucher, um Texte und Schriftarten korrekt darzustellen. Dazu nehmen die Browser der Website-Besucher üblicherweise Verbindung zu den Servern von Adobe auf. Dadurch erfährt Adobe die IP-Adresse des jeweiligen Seitenbesuchers. Die Nutzung von Adobe Fonts erfolgt im Interesse einer einheitlichen und ansprechenden Darstellung unserer Online-Angebote. Dies stellt ein berechtigtes Interesse im Sinne von Art. 6 Abs. 1 lit. f DSGVO dar. Wenn der Browser des jeweiligen Seitenbesuchers Adobe Fonts nicht unterstützt, wird eine Standardschrift vom jeweiligen Computer des Seitenbesuchers genutzt."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Weitere Informationen zu Adobe Fonts sind unter: "),
            _c(
              "a",
              {
                attrs: {
                  href:
                    "https://www.adobe.com/de/privacy/policies/adobe-fonts.html",
                  target: "_blank"
                }
              },
              [
                _vm._v(
                  "https://www.adobe.com/de/privacy/policies/adobe-fonts.html"
                )
              ]
            ),
            _vm._v(
              " zu finden. Die Datenschutzrichtlinie von Adobe finden Sie unter: "
            ),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.adobe.com/de/privacy/policy.html",
                  target: "_blank"
                }
              },
              [_vm._v("https://www.adobe.com/de/privacy/policy.html")]
            )
          ]),
          _vm._v(" "),
          _c("h4", [_c("strong", [_vm._v("XI. Soziale Medien")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Auf unseren Seiten befinden sich „Share“-Buttons für soziale Medien wie Facebook, Google+, Twitter und Xing. Diese ermöglichen das Teilen von Inhalten auf sozialen Netzwerken. Sie sind als externe Links umgesetzt. Eine Übertragung der Nutzerdaten findet erst nach einem Klick auf den Link statt und erfolgt auf der Website des jeweiligen sozialen Netzwerks. Weitere Informationen zur Verarbeitung Ihrer Nutzerdaten auf dem sozialen Netzwerk finden Sie in den Datenschutzerklärungen der jeweiligen sozialen Netzwerke."
            )
          ]),
          _vm._v(" "),
          _c("h4", [
            _c("strong", [_vm._v("XII. Rechte der betroffenen Person")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Werden personenbezogene Daten von Ihnen verarbeitet, sind Sie Betroffener i.S.d. DSGVO und es stehen Ihnen folgende Rechte gegenüber dem Verantwortlichen zu:"
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("1. Auskunftsrecht")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben das Recht, jederzeit von uns unentgeltliche Auskunft sowie Bestätigung über die zu Ihrer Person gespeicherten personenbezogenen Daten und eine Kopie dieser Auskunft zu erhalten."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("2. Recht auf Berichtigung ")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben ein Recht auf Berichtigung und/oder Vervollständigung gegenüber dem Verantwortlichen, sofern die verarbeiteten personenbezogenen Daten, die Sie betreffen, unrichtig oder unvollständig sind. Der Verantwortliche hat die Berichtigung unverzüglich vorzunehmen."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("3. Recht auf Einschränkung der Verarbeitung")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben das Recht die Einschränkung der Verarbeitung zu verlangen, wenn eine der folgenden Voraussetzungen gegeben ist:"
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Die Richtigkeit der personenbezogenen Daten wird von Ihnen bestritten, und zwar für eine Dauer, die es uns ermöglicht, die Richtigkeit der personenbezogenen Daten zu überprüfen."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Die Verarbeitung ist unrechtmäßig, Sie lehnen die Löschung der personenbezogenen Daten ab und verlangen stattdessen die Einschränkung der Nutzung der personenbezogenen Daten. "
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Wir benötigen die personenbezogenen Daten für die Zwecke der Verarbeitung nicht länger, Sie benötigen sie jedoch zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Sie haben Widerspruch gegen die Verarbeitung gem. Art. 21 Abs. 1 DS-GVO eingelegt und es steht noch nicht fest, ob unsere berechtigten Gründe gegenüber Ihren überwiegen."
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("4. Recht auf Löschung")])]),
          _vm._v(" "),
          _c("p", [_vm._v("a) Löschungspflicht")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie können von dem Verantwortlichen verlangen, dass die Sie betreffenden personenbezogenen Daten unverzüglich gelöscht werden, und der Verantwortliche ist verpflichtet, diese Daten unverzüglich zu löschen, sofern einer der folgenden Gründe zutrifft:"
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "Die Sie betreffenden personenbezogenen Daten sind für die Zwecke, für die sie erhoben oder auf sonstige Weise verarbeitet wurden, nicht mehr notwendig."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Sie widerrufen Ihre Einwilligung, auf die sich die Verarbeitung gem. Art. 6 Abs. 1 lit. a oder Art. 9 Abs. 2 lit. a DSGVO stützte, und es fehlt an einer anderweitigen Rechtsgrundlage für die Verarbeitung."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Sie legen gem. Art. 21 Abs. 1 DSGVO Widerspruch gegen die Verarbeitung ein und es liegen keine vorrangigen berechtigten Gründe für die Verarbeitung vor, oder Sie legen gem. Art. 21 Abs. 2 DSGVO Widerspruch gegen die Verarbeitung ein."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Die Sie betreffenden personenbezogenen Daten wurden unrechtmäßig verarbeitet."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Die Löschung der Sie betreffenden personenbezogenen Daten ist zur Erfüllung einer rechtlichen Verpflichtung nach dem Unionsrecht oder dem Recht der Mitgliedstaaten erforderlich, dem der Verantwortliche unterliegt."
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "Die Sie betreffenden personenbezogenen Daten wurden in Bezug auf angebotene Dienste der Informationsgesellschaft gemäß Art. 8 Abs. 1 DSGVO erhoben."
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("b) Information an Dritte")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Hat der Verantwortliche die Sie betreffenden personenbezogenen Daten öffentlich gemacht und ist er gem. Art. 17 Abs. 1 DSGVO zu deren Löschung verpflichtet, so trifft er unter Berücksichtigung der verfügbaren Technologie und der Implementierungskosten angemessene Maßnahmen, auch technischer Art, um für die Datenverarbeitung Verantwortliche, die die personenbezogenen Daten verarbeiten, darüber zu informieren, dass Sie als betroffene Person von ihnen die Löschung aller Links zu diesen personenbezogenen Daten oder von Kopien oder Replikationen dieser personenbezogenen Daten verlangt haben."
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("c) Ausnahmen")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Das Recht auf Löschung besteht nicht, soweit die Verarbeitung erforderlich ist"
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "zur Erfüllung einer rechtlichen Verpflichtung, die die Verarbeitung nach dem Recht der Union oder der Mitgliedstaaten, dem der Verantwortliche unterliegt, erfordert;"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen."
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("5. Recht auf Unterrichtung")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Haben Sie das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung gegenüber dem Verantwortlichen geltend gemacht, ist dieser verpflichtet, allen Empfängern, denen die Sie betreffenden personenbezogenen Daten offengelegt wurden, diese Berichtigung oder Löschung der Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand verbunden."
            ),
            _c("br"),
            _vm._v(
              "Ihnen steht gegenüber dem Verantwortlichen das Recht zu, über diese Empfänger unterrichtet zu werden."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [_vm._v("6. Recht auf Datenübertragbarkeit")])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben das Recht, die Sie betreffenden personenbezogenen Daten, die Sie dem Verantwortlichen bereitgestellt haben, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten. Außerdem haben Sie das Recht diese Daten einem anderen Verantwortlichen ohne Behinderung durch den Verantwortlichen, dem die personenbezogenen Daten bereitgestellt wurden, zu übermitteln, sofern"
            )
          ]),
          _vm._v(" "),
          _c("ol", [
            _c("li", [
              _vm._v(
                "die Verarbeitung auf einer Einwilligung gem. Art. 6 Abs. 1 lit. a DSGVO oder Art. 9 Abs. 2 lit. a DSGVO oder auf einem Vertrag gem. Art. 6 Abs. 1 lit. b DSGVO beruht und"
              )
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "die Verarbeitung mithilfe automatisierter Verfahren erfolgt."
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "In Ausübung dieses Rechts haben Sie ferner das Recht, zu erwirken, dass die Sie betreffenden personenbezogenen Daten direkt von einem Verantwortlichen einem anderen Verantwortlichen übermittelt werden, soweit dies technisch machbar ist. Freiheiten und Rechte anderer Personen dürfen hierdurch nicht beeinträchtigt werden."
            )
          ]),
          _vm._v(" "),
          _c("p", [_c("strong", [_vm._v("7. Widerspruchsrecht")])]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben das Recht, aus Gründen, die sich aus ihrer besonderen Situation ergeben, jederzeit gegen die Verarbeitung der Sie betreffenden personenbezogenen Daten, die aufgrund von Art. 6 Abs. 1 lit. e oder f DSGVO erfolgt, Widerspruch einzulegen; dies gilt auch für ein auf diese Bestimmungen gestütztes Profiling. "
            ),
            _c("br"),
            _vm._v(
              "Der Verantwortliche verarbeitet die Sie betreffenden personenbezogenen Daten nicht mehr, es sei denn, er kann zwingende schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen."
            ),
            _c("br"),
            _vm._v(
              "Sie haben die Möglichkeit, im Zusammenhang mit der Nutzung von Diensten der Informationsgesellschaft – ungeachtet der Richtlinie 2002/58/EG – Ihr Widerspruchsrecht mittels automatisierter Verfahren auszuüben, bei denen technische Spezifikationen verwendet werden."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v(
                "8. Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung"
              )
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Sie haben das Recht, Ihre datenschutzrechtliche Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt."
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _c("strong", [
              _vm._v("9. Recht auf Beschwerde bei einer Aufsichtsbehörde")
            ])
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat Ihres Aufenthaltsorts, Ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes, zu, wenn Sie der Ansicht sind, dass die Verarbeitung der Sie betreffenden personenbezogenen Daten gegen die DSGVO verstößt. "
            ),
            _c("br"),
            _vm._v(
              "Die Aufsichtsbehörde, bei der die Beschwerde eingereicht wurde, unterrichtet den Beschwerdeführer über den Stand und die Ergebnisse der Beschwerde einschließlich der Möglichkeit eines gerichtlichen Rechtsbehelfs nach Art. 78 DSGVO."
            ),
            _c("br"),
            _vm._v("Die für uns zuständige Behörde ist:")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Berliner Beauftragter für Datenschutz und Informationsfreiheit"
            ),
            _c("br"),
            _vm._v("Friedrichstr. 219"),
            _c("br"),
            _vm._v("10969 Berlin"),
            _c("br"),
            _vm._v("Tel.: +49 30 13889-0"),
            _c("br"),
            _vm._v("Fax: +49 30 2155050"),
            _c("br"),
            _vm._v("E-Mail: "),
            _c(
              "a",
              { attrs: { href: "mailto:mailbox@datenschutz-berlin.de" } },
              [_vm._v("mailbox@datenschutz-berlin.de")]
            )
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }